import { Component } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ActivityWatcher } from './activity-watcher.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  constructor(router: Router, activityWatcher: ActivityWatcher) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        activityWatcher.startNewActivity((event as NavigationStart).url);
      }
    });
  }
}
